import Breadcrumb from './Breadcrumb';
import BreadcrumbItem from './BreadcrumbItem';

Breadcrumb.Item = BreadcrumbItem;
export default Breadcrumb;



// WEBPACK FOOTER //
// ./_antd1.11.2/breadcrumb/index.jsx